<script>
import UserDetailTableTile from '@/components/user/tiles/UserDetailTableTile.vue';

// пока не нашел, где взять нужные данные

export default {
  name: 'UserDetailHistoryTab',
  components: { UserDetailTableTile },
  computed: {
    eventRowsConfig() {
      return [
        { cellType: 'default',     cellData: { date: '20.12.2023',    eventData: { title: 'Регистрация аккаунта'                                                                                         }  },  }, // eslint-disable-line
        { cellType: 'tariff',      cellData: { date: '26.12.2023',    eventData: { title: 'Смена тарифа',           value: 'Бесплатный',                                            addValue: 'Премиум'  }  },  }, // eslint-disable-line
        { cellType: 'default',     cellData: { date: '26.01.2024',    eventData: { title: 'Продление тарифа',       value: 'Премиум',                                               addValue: '+3 370 ₽' }  },  }, // eslint-disable-line
        { cellType: 'default',     cellData: { date: '04.02.2024',    eventData: { title: 'Создание проекта',       value: 'Сотрудничество со студией дизайна "Grand Interior"'                          }  },  }, // eslint-disable-line
        { cellType: 'default',     cellData: { date: '15.02.2024',    eventData: { title: 'Перемещение проекта',    value: 'Сотрудничество со студией дизайна "Grand Interior"',    addValue: 'в архив'  }  },  }, // eslint-disable-line
        { cellType: 'user',        cellData: { date: '15.02.2024',    eventData: { title: 'Добавление реферала',    value: 'Константин Константинопольский',                        addValue: null       }  },  }, // eslint-disable-line
      ];
    },

    headers() {
      return [
        { title: 'Дата',      width: 15,    component: 'BaseTableCell',         props: (item) => ({ value: item.cellData.date }),   required: true           }, // eslint-disable-line
        { title: 'Событие',   width: 85,    component: 'BaseTableEventCell',    props: (item) => ({ value: item.cellData.eventData,   type: item.cellType }) }, // eslint-disable-line
      ];
    },

    historyEvents() {
      return [
        { title: 'Дата регистрации', value: '12.20.2023' },
        { title: 'Дата активации',   value: '12.20.2023' }, // eslint-disable-line
      ];
    },
  },
};
</script>

<template lang="pug">
.b-user-detail-history-tab
  UserDetailTableTile._history-table(:headers="headers" :items="eventRowsConfig" label="История аккаунта")
  ._history-events
    ._history-events-header Главные события
    ._history-events-data
      ._history-events-row(v-for="event in historyEvents" :key="event.title")
        ._history-events-title {{ event.title }}
        ._history-events-value {{ event.value }}
</template>

<style scoped lang="scss">
.user-detail-history-tab {
  display: grid;
  grid-template-columns: 1fr 312px;
  gap: 38px;

  &__history-table {
    grid-column: 1;
    grid-row: 1 / 2 span
  }

  &__history-events {
    padding: 32px 25px 25px 25px;
    grid-column: 2;
    grid-row: 1;
    border-radius: 8px;
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.08);
    background: rgb(255, 255, 255);
  }

  &__history-events-header {
    color: rgb(30, 49, 71);
    font-family: Geometria, sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
    border-bottom: 1px solid rgb(235, 239, 242);
    padding-bottom: 15px;
  }

  &__history-events-data {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding-top: 25px;
  }

  &__history-events-row {
    display: flex;
    justify-content: space-between;
  }

  &__history-events-title {
    color: rgb(146, 160, 176);
    font-family: Geometria, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: normal;
    text-align: left;
  }

  &__history-events-value {
    color: rgb(30, 49, 71);
    font-family: Geometria, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: normal;
    text-align: right;
  }
}
</style>
